import { Interface } from 'ethers/lib/utils.js';
import abi from '../abi';
import { MARKET_ADDRESES } from '../addresses';
import { getSynthetixConnector } from './version';
import type { MarketIdentifiers } from '$lib/types/market';
import type { IConnectorReturnData } from '../types';

export async function cancelStandardOrder(
	marketIdentifier: MarketIdentifiers
): Promise<IConnectorReturnData> {
	const target = await getSynthetixConnector(marketIdentifier);
	const synthethixInterface = new Interface(abi.scWalletSynthetixPerpV2);
	const tradeEncodedData = synthethixInterface.encodeFunctionData('cancelOrder', [
		MARKET_ADDRESES[marketIdentifier]
	]);

	return {
		_target: target,
		_callData: tradeEncodedData
	};
}

export async function cancelLimitOrder(orderId: string): Promise<IConnectorReturnData> {
	const target: string = 'Synthetix-Perp-Limit-Order-v1.1';
	const synthethixLimitOrderInterface = new Interface(abi.scWalletSynthetixPerpV2LimitOrder);

	const tradeEncodedData = synthethixLimitOrderInterface.encodeFunctionData('cancelLimitOrder', [
		orderId,
		false
	]);

	return {
		_target: target,
		_callData: tradeEncodedData
	};
}

export async function executeDelayedOrder(
	market: `0x${string}`,
	priceUpdateData: string[]
): Promise<IConnectorReturnData> {
	const target: string = await getSynthetixConnector();
	const synthethixInterface = new Interface(abi.scWalletSynthetixPerpV2);
	const tradeEncodedData = synthethixInterface.encodeFunctionData('execute', [
		market,
		priceUpdateData
	]);
	return {
		_target: target,
		_callData: tradeEncodedData
	};
}
